import * as jose from 'jose'
import { JITSI_SECRET_KEY, sucessErrorMsg } from './constants'

export async function decodeJwe(key: string) {
  let jweToken = ''
  const secretKey = new TextEncoder().encode(JITSI_SECRET_KEY)

  try {
    const { plaintext } = await jose.compactDecrypt(key, secretKey)
    jweToken = new TextDecoder().decode(plaintext)
  } catch (error) {
    console.error(error)
  }
  return jweToken
}

export async function fetchJitsiToken(): Promise<string> {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_GATEWAY_URL}${process.env.REACT_APP_JITSI_TOKEN_ENDPOINT}`
    )
    if (!response.ok) {
      throw new Error(sucessErrorMsg?.tokenFetchError)
    }
    const key = await response.text()
    if (!key) {
      console.error(sucessErrorMsg?.noKeyReturned)
      return ''
    }
    const jwtToken = await decodeJwe(key)
    return jwtToken
  } catch (error) {
    console.error(error)
    return ''
  }
}
